import { useAccountStatus, useSetWeightUnit } from "../lib/queries";
import { ErrorState } from "./Loading";

/**
 * Which unit the walkthrough starts on when logging a weight.
 *
 * A default only. Every logged set stores the unit it was actually recorded in, so switching this
 * later never reinterprets history -- 40 lb does not silently become 40 kg because a preference
 * changed. "Bodyweight" isn't offered here because it is a per-set answer, not a preference.
 */
export function WeightUnitSetting() {
  const status = useAccountStatus();
  const setUnit = useSetWeightUnit();
  const current = status.data?.weight_unit ?? "lb";

  return (
    <>
      <h2>Units</h2>
      <p className="form-hint">
        Which unit to start on when logging a weight. Sets already logged keep the unit they were
        recorded in.
      </p>
      {setUnit.isError && <ErrorState error={setUnit.error} />}
      <div className="filter-chips" role="group" aria-label="Weight unit">
        {(["lb", "kg"] as const).map((unit) => (
          <button
            key={unit}
            type="button"
            className={`chip ${current === unit ? "active" : ""}`}
            aria-pressed={current === unit}
            disabled={setUnit.isPending}
            onClick={() => setUnit.mutate(unit)}
          >
            {unit === "lb" ? "Pounds (lb)" : "Kilograms (kg)"}
          </button>
        ))}
      </div>
    </>
  );
}
